<template>
    <div class="bundle-accordion-element"
        @mouseover="showBlockActionButtons = true" 
        @mouseleave="showBlockActionButtons = false" 
    >
        <div v-if="showBlockActionButtons" :id="titleId+'-tooltip-delete'" class="delete-child-icon" @click="confirmBlockDelete = true">
            <i class="fas fa-times"></i>
        </div>

        <b-tooltip v-if="showBlockActionButtons" :target="titleId+'-tooltip-delete'">
            <div class="delete-block-tooltip">Delete</div>
        </b-tooltip>

        <div class="confirm-block-deletion" v-if="confirmBlockDelete">
            <h4>Permanent Action</h4>
            <p>Are you sure you want to delete this accordion element?</p>
            <span @click="deleteChildBlock(arrayIndex)" class="confirm-delete-block-action">
                <i class="far fa-trash-alt"></i>Yes, delete.
            </span>
            <span @click="confirmBlockDelete = false">
                <i class="fas fa-ban"></i>Cancel.
            </span>
        </div>

        <div class="block-drag-handle" v-if="showBlockActionButtons">
            <i class="fas fa-ellipsis-h"></i>
        </div>

        <div class="bundle-accordion-title">
            <input v-if="globalSettings.elementGuidesOnlyDashboard" class="div-like-input div-like-input-accordion-title" v-model="accordionTitle.titleText" type="text">

            <component v-if="!globalSettings.elementGuidesOnlyDashboard" :is="settingsFromWeebly.settings.titleTag">{{accordionTitle.titleText}}</component>

        </div>
        <div class="bundle-accordion-content">
            {content-{{titleId}}:content}
        </div>
    </div>
</template>

<script>
export default {

    props: ['titleId', 'arrayIndex','accordionTitle'],

    name: 'AccordionTitle',

    data() {
        return {
            
            editable_dashboard: true,

            // show child block action buttons: settings + delete
            showBlockActionButtons: false,
            showChildSettings: false,

            confirmBlockDelete: false,

        }
    },

    methods: {

        updateTitle(arrayIndex) {
            // console.log(this.$store.state.weeblySettings.settings.accordionTitles[arrayIndex].titleText)
            // this.$store.state.weeblySettings.settings.accordionTitles[arrayIndex].titleText = event.target.innerText
        },

        showChildBlockSettings(titleId) {
            console.log(titleId)
        },

        deleteChildBlock(arrayIndex) {
            
            this.$store.state.weeblySettings.settings.accordionTitles.splice(this.arrayIndex, 1)
            this.confirmBlockDelete = false;

        }

    },

    computed: {
        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        // get array of titles
        accordionTitlesArray() {
            return this.$store.state.weeblySettings.settings.accordionTitles
        },

        globalSettings() {
            return this.$store.state
        }

    }

}
</script>

<style lang="less">
@import '../../../../less/colors.less';

.bundle-accordion-element {
    position: relative;
}
.access-settings-tooltip, .delete-block-tooltip {
    background: @action_blue;
    padding: 7px;
    font-weight: 700;
}

.delete-block-tooltip {
    background: @warning_red;
}
.confirm-block-deletion {
    position: absolute;
    top: 7px;
    right: 7px;
    width: 350px;
    background: #fff;
    border: 1px solid @shark_light;
    z-index: 1000;
    font-size: 12px;
    border-radius: .25rem;
    text-align: center;
    box-shadow: 0 4px 10px fade(@shark_light, 25%);

    h4 {
        font-size: 20px;
        font-weight: 400;
        background: @shark_light;
        color: #fff;
        padding: 10px;
    }

    p {
        font-size: 13px;
        padding: 15px;
        margin: 0;
    }

    span {
        margin: 5px 5px 15px;
        display: inline-block;
        font-weight: 700;
        cursor: pointer;
        color: @text_grey;
        font-size: 13px;
        padding: 7px 12px;
        background: fade(@shark_light,12%);
        border-radius: .25rem;

        &:hover {
            opacity: .9;
        }

        i {
            margin-right: 7px;
        }
    }

    .confirm-delete-block-action {
        background: @warning_red;
        color: #fff;
    }
}

.block-drag-handle {
    position: absolute;
    top: -7px;
    left: 50%;
    height: 20px;
    width: 34px;
    margin-left: -17px;
    background: #fff;
    cursor: move;
    z-index: 10;
    border-radius: .25rem;
    text-align: center;
    border: 1px solid @action_blue;

    i {
        font-size: 10px;
        line-height: 20px;
        color: @action_blue;
    }
}

.settings-child-icon {
    position: absolute;
    top: -7px;
    left: -7px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: @action_blue;
    border-radius: .25rem;
    cursor: pointer;
    z-index: 10;
    
    i {
        color: #fff;
        font-size: 10px;
        line-height: 20px;
        
    }

    &:hover {
        background: fade(@action_blue, 85%);
    }
}

.delete-child-icon {
    z-index: 10;
    position: absolute;
    top: -7px;
    right: -7px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    background: @warning_red;
    border-radius: .25rem;
    cursor: pointer;

    i {
        color: #fff;
        font-size: 12px;
        line-height: 20px;
    }

    &:hover {
        background: fade(@warning_red, 85%);
    }
}

.sortable-chosen {
    opacity: .7;
    border: 1px solid @action_blue;
}
.ghost-block {
    background: @action_blue!important;
    opacity: .2;
}

input.div-like-input {
    padding: 0;
    margin: 0;
    line-height: 1;
    width: 100%;
    outline: none!important;
    background: none;
    border: 0;
}

.dummy-title {
    font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/components/elements/elementSettings/accordiontitles/AccordionTitle.vue